import styled from '@emotion/styled';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { DialogTitleWithColor } from '../../../../components/DialogTitleWithColor';
import { useUnsafeTranslation } from '../../../../i18next';
import { useRoutes } from '../../../../routes';
import { useCurrentUser } from '../../../../services/currentUser';
import { isFreeTierOrg } from '../../../../services/organizationTier';

const HEIGHT = 350;

const StyledAnchor = styled('a')`
  color: ${(p) => p.theme.palette.primary.main};
`;

const InvitationSuccessDialog = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const user = useCurrentUser();
  const { t } = useUnsafeTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitleWithColor color="green">
        {t("Hi {{preferredName}}, it's good to have you on board!", {
          preferredName: user.preferredName
        })}
      </DialogTitleWithColor>
      <DialogContent>
        <p>
          {t(
            "This is {{orgName}}'s dashboard, where you’ll find an overview of the current activity in your organization.",
            { orgName: user.org.name }
          )}
        </p>
        <Trans i18nKey={'adminInvitationSuccessMessage'}>
          Check out our
          <StyledAnchor
            rel="noopener noreferrer"
            target="_blank"
            href="https://help.dadohr.com/article/47-5-minute-introduction-to-dado"
          >
            help center
          </StyledAnchor>
          for a guide to getting started. Please don't hesitate to get in touch
          with <strong>help@dadohr.com</strong> with any questions the help
          enter can't answer.
        </Trans>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const PageHomeOverview = () => {
  const currentUser = useCurrentUser();
  const { org } = currentUser;
  const { ROUTES, goTo, getQuery } = useRoutes();
  const { t } = useTranslation();

  if (isFreeTierOrg(org)) {
    return <Redirect to={ROUTES.moments.overview.url()} />;
  }

  // this eliminates the home page for now but if someone bookmarked /home, redirect them
  return <Redirect to={ROUTES.experiences.overview.url()} />;

  // return (
  //   <PageBody noTopPadding>
  //     <PageToolbar>
  //       <PageToolbarTitle>
  //         <Typography variant="h1" component="h1">
  //           {org.name}
  //         </Typography>
  //       </PageToolbarTitle>
  //     </PageToolbar>
  //     <Grid container direction="row" justify="space-between" spacing={4}>
  //       <Grid item xs={12} sm={7} xl={9}>
  //         <Section>
  //           <DashboardStatistics currentUser={currentUser} />
  //         </Section>
  //         <Section>
  //           <SectionTitle>
  //             <Typography variant="h2" component="h2">
  //               {t('Daily Completed Tasks')}
  //             </Typography>
  //           </SectionTitle>
  //           <DailyCompletedTasks currentUser={currentUser} height={HEIGHT} />
  //         </Section>
  //         <Section>
  //           <SectionTitle>
  //             <Link to={ROUTES.experiences.overview.url()}>
  //               <Typography variant="h2" component="h2">
  //                 {t('Active Experiences')}
  //               </Typography>
  //             </Link>
  //           </SectionTitle>
  //           <ActiveExperiencesGrid currentUser={currentUser} />
  //         </Section>
  //       </Grid>
  //       <Grid item xs={12} sm={5} xl={3}>
  //         <Card variant="outlined">
  //           <SectionTitle>
  //             <Typography variant="h3" component="h3">
  //               {t('Activity Log')}
  //             </Typography>
  //           </SectionTitle>
  //           <ActivityLog orgId={org.id} />
  //         </Card>
  //       </Grid>
  //     </Grid>
  //     <InvitationSuccessDialog
  //       open={getQuery().source === 'invitation'}
  //       onClose={() => goTo(ROUTES.home.overview.url())}
  //     />
  //   </PageBody>
  // );
};
